import { AuthenticatedProps } from './types';

const Authenticated = ({ children }: AuthenticatedProps) => {
  return (
    <>
      <div className="u-flex u-min-h-port">
        <div className="u-flex u-column u-grow">{children}</div>
      </div>
      <style jsx>{`
        .u-flex {
          display: flex;
        }

        .u-column {
          flex-direction: column;
        }

        .u-min-h-port {
          min-height: 100vh;
        }

        .u-grow {
          flex-grow: 1;
        }
      `}</style>
    </>
  );
};

export default Authenticated;
